<div class="legal-gate">
  <c-container class="legal-gate__container">

    <header class="legal-gate__header">
      <app-logo class="legal-gate__logo"></app-logo>
      <h1 class="legal-gate__title">{{ 'legal.acknowledge.title' | translate }}</h1>
      <p class="legal-gate__intro">{{ 'legal.acknowledge.intro' | translate }}</p>
    </header>

    @if (loading()) {
      <div class="legal-gate__state">
        <c-spinner color="primary"></c-spinner>
        <p class="mt-3 text-body-secondary">{{ 'legal.acknowledge.loading' | translate }}</p>
      </div>
    } @else if (loadError()) {
      <c-alert color="danger">
        <strong>{{ 'legal.acknowledge.error_title' | translate }}</strong>
        <p class="mb-2">{{ 'legal.acknowledge.error_message' | translate }}</p>
        <button cButton color="danger" variant="outline" (click)="load()">
          {{ 'legal.acknowledge.retry' | translate }}
        </button>
      </c-alert>
    } @else {

      @if (versionConflict()) {
        <c-alert color="warning">{{ 'legal.acknowledge.version_conflict' | translate }}</c-alert>
      }

      @if (submitError(); as key) {
        <!-- A rejected save, not a failed load — the documents are still on screen and
             the user's ticks are intact, so keep them there and explain. -->
        <c-alert color="danger">{{ key | translate }}</c-alert>
      }

      @for (entry of documents(); track entry.document.key) {
        <c-card class="legal-gate__doc mb-4">
          <c-card-body>
            <h2 class="legal-gate__doc-title">{{ entry.document.title }}</h2>
            <p class="legal-gate__doc-meta">
              {{ 'legal.acknowledge.version_label' | translate }} {{ entry.document.version }}
            </p>

            <!-- Server-rendered policy fragment. Trusted: it is operator-authored ERB
                 from the repo, served by our own API — the same content the public
                 compliance pages render. -->
            <div class="legal-gate__doc-body" [innerHTML]="entry.body | safeHtml"></div>

            <div class="legal-gate__check form-check">
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'legal-check-' + entry.document.key"
                [checked]="entry.checked"
                (change)="toggle(entry.document.key)">
              <label class="form-check-label" [for]="'legal-check-' + entry.document.key">
                {{ entry.document.checkbox | translate }}
              </label>
            </div>
          </c-card-body>
        </c-card>
      }

      <div class="legal-gate__actions">
        <button
          cButton
          color="primary"
          size="lg"
          [disabled]="!canSubmit()"
          (click)="onAccept()">
          @if (submitting()) {
            <c-spinner size="sm" aria-hidden="true"></c-spinner>
          }
          {{ 'legal.acknowledge.agree' | translate }}
        </button>
        <button cButton color="secondary" variant="outline" [disabled]="submitting()" (click)="onDecline()">
          {{ 'legal.acknowledge.decline' | translate }}
        </button>
      </div>

      <p class="legal-gate__footnote">{{ 'legal.acknowledge.footnote' | translate }}</p>
    }

  </c-container>
</div>
